import React from 'react';
import { Route } from 'react-router-dom';

import ContratosFicha from '../../Contratos/contratos/ContratosFicha';
import ContratosIndex from '../../Contratos/contratos/ContratosIndex';

const ContratosRoutes = () => {
  return (
    <>
      {/* Contratos */}
      <Route path="contratos/contratos" element={<ContratosIndex />} />
      <Route
        path="contratos/contratos/ficha/dadosgerais"
        element={<ContratosFicha />}
      />
      <Route
        path="contratos/contratos/ficha/:id/dadosgerais"
        element={<ContratosFicha />}
      />
    </>
  );
};

export default ContratosRoutes;
